/**
 * applyStrikeModifier — pure helper extracted from coreSlice.nextDay
 * (03/06/2026 round 2 refactor of the daily P&L block).
 *
 * Applies the national-strike or blocage-routier revenue penalty AFTER
 * the difficulty multiplier so the player sees a clear cut on their
 * actual day revenue. The strike auto-expires when totalDays + 1 >
 * companyStrike.until (cleanup happens elsewhere in nextDay).
 *
 * Side-effects: none.
 *
 * @param {Object} state - the current game state snapshot
 * @param {number} dayRevenue - the post-difficulty revenue for the day
 * @returns {{ dayRevenue: number, strikeNotice: Object|null }}
 */
import { generateId } from '../helpers';

export function applyStrikeModifier(state, dayRevenue) {
  const strike = state.companyStrike;
  if (!strike) return { dayRevenue, strikeNotice: null };
  const isActive = (state.totalDays + 1) <= (strike.until || 0);
  const hasPenalty = (strike.revenuePenalty || 0) > 0;
  if (!isActive || !hasPenalty) return { dayRevenue, strikeNotice: null };

  const revenueLost = Math.round(dayRevenue * strike.revenuePenalty);
  const newRevenue = Math.max(0, dayRevenue - revenueLost);
  const strikeNotice = {
    id: generateId(),
    type: 'strike_impact',
    title: strike.label || 'Mouvement social',
    message: strike.revenuePenalty >= 0.99
      ? `Aucun revenu aujourd'hui (${strike.label}).`
      : `${Math.round(strike.revenuePenalty * 100)} % de revenus perdus aujourd'hui (${strike.label}).`,
    day: state.totalDays + 1,
    read: false,
  };
  return { dayRevenue: newRevenue, strikeNotice };
}
